import { CONFIG, setOkta } from 'module/authentication/okta/config';
import { transformOktaAuthenticationState } from 'module/authentication/token/okta-authentication-state';
import { logger } from 'module/logger';
import { PageLoading } from 'module/ui/components/atoms/loading';
import OktaAuth from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { Outlet } from '@rocketlane/rocket-router';
import { useAccountMetaQuery } from 'queries/account';
import { Suspense, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { ROUTE_PATHS } from 'routes/route-paths';

export const OKTA_REDIRECT_URI = window.location.origin;
const voidFunction = () => {};

export const SetupOkta = () => {
  const { data, isLoading, error } = useAccountMetaQuery();
  const [oktaAuth, setOktaAuth] = useState<OktaAuth | null>();

  useEffect(() => {
    if (data) {
      const {
        okta: { clientId, issuerDomain },
      } = data;
      const oktaConfig = CONFIG({
        issuer: issuerDomain,
        clientId,
        postLoginRedirectUri: `${OKTA_REDIRECT_URI}/${ROUTE_PATHS.LOGIN_CALLBACK}`,
        postLogoutRedirectUri: `${OKTA_REDIRECT_URI}/${ROUTE_PATHS.LOGIN}`,
        transformAuthState: transformOktaAuthenticationState,
      });
      const authInstance = new OktaAuth(oktaConfig);

      setOkta(authInstance);
      setOktaAuth(authInstance);
    }
    if (error) {
      logger.error('Account meta failed', { error: error as Error });
    }

    return () => {
      setOkta(null);
      setOktaAuth(null);
    };
  }, [data, error]);

  if (isLoading || !oktaAuth || !data) {
    return <PageLoading />;
  }

  return (
    <Suspense fallback={<PageLoading />}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={voidFunction}>
        <Helmet
          titleTemplate={`%s - ${data.company.companyName}`}
          defaultTitle={data.company.companyName}
        >
          <link
            rel="icon"
            type="image/png"
            href={data.company.companyLogoUrl}
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href={data.company.companyLogoUrl}
          />
        </Helmet>
        <Outlet />
      </Security>
    </Suspense>
  );
};
